/**
 * electric claimable status <claimId>
 *
 * Checks the provisioning state of a claimable source.
 * Shows the claim link when ready so the user can proceed.
 * This is a public endpoint — no authentication required.
 */

import { Command } from 'commander'
import { createPublicClient, getDashboardUrl } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printKeyValue } from '../../output.js'

export const claimStatusCommand = new Command(`status`)
  .description(`Check provisioning status`)
  .argument(`<claimId>`, `Claim ID`)
  .action(async (claimId: string) => {
    const json = claimStatusCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createPublicClient()
      const result = await client.claimable.get({ claimId })

      if (isQuiet()) {
        printQuiet(result.state)
        return
      }

      if (json) {
        printJson(result)
      } else {
        const pairs: [string, string][] = [[`State:`, result.state]]
        if (result.claim_link) {
          pairs.push([
            `Claim link:`,
            `${getDashboardUrl()}/claim?uuid=${claimId}`,
          ])
        }
        if (result.connection_uri) {
          pairs.push([`Database URL:`, result.connection_uri])
        }
        if (result.service_type) {
          pairs.push([`Service type:`, result.service_type])
        }
        if (result.error) {
          pairs.push([`Error:`, result.error])
        }
        printKeyValue(pairs)

        if (result.state === `ready` && result.claim_link) {
          process.stderr.write(
            `\nReady to claim. Run: electric claimable claim ${claimId}\n`
          )
        }
      }
    } catch (error) {
      await handleError(error, json)
    }
  })
